import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { BackendUnreacheableComponent, LogoutComponent, PageForbiddenComponent, PageNotFoundComponent } from '@damofire/uix-commons';
import { damoAuthRoutes } from '@damotech/damoauth-lib';
import { environment } from '../environments/environment';
import { AuthComponent } from './security/auth/auth.component';
import { ForceUpdateComponent } from './security/force-update/force-update.component';

const routes: Routes = [
  {
    path: 'auth',
    component: AuthComponent,
    children: damoAuthRoutes,
  },
  { path: 'dashboard', loadChildren: () => import('./dashboard/dashboard.module').then((m) => m.DashboardModule) },
  { path: 'storage', loadChildren: () => import('./storage/storage.module').then((m) => m.StorageModule) },
  { path: 'stax', loadChildren: () => import('./stax/stax.module').then((m) => m.StaxModule) },
  { path: 'nexus', loadChildren: () => import('./nexus/nexus.routes').then((m) => m.NEXUS_ROUTES) },
  { path: 'repos', loadChildren: () => import('./repos/repos.module').then((m) => m.ReposModule) },
  { path: 'production', loadChildren: () => import('./df/df.module').then((m) => m.DfModule) },
  { path: 'warehouses', loadChildren: () => import('./watson/watson.module').then((m) => m.WatsonModule) },
  { path: 'import', redirectTo: 'warehouses/import' },
  { path: '404', component: PageNotFoundComponent },
  { path: '403', component: PageForbiddenComponent },
  { path: '502', component: BackendUnreacheableComponent },
  { path: 'latest', component: ForceUpdateComponent },
  { path: 'logout', component: LogoutComponent },
  { path: 'login', redirectTo: 'auth' },
  { path: '**', redirectTo: 'dashboard' },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { enableTracing: false, useHash: environment.target === 'app', paramsInheritanceStrategy: 'always' })],
  exports: [RouterModule],
})
export class AppRoutingModule {}
